var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"input",staticClass:"v-editor",style:(_vm.style),attrs:{"spellcheck":"false","context":_vm.context,"contenteditable":""},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }